// src/pages/DashboardPage.js
// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import styled from 'styled-components';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import DashboardShopPurchases from '../components/ui/dashboard/shopPurchases';
import DashboardArcaniumPurchases from '../components/ui/dashboard/arcaniumPurchases';
import DashboardCharacterInfo from '../components/ui/dashboard/characterInfo';

const DashboardPage = () => {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const [selectedSection, setSelectedSection] = useState('character');

  if (!loading && !user) {
    return <Navigate to="/" replace />;
  }

  const sections = {
    character: t('dashboard.characterInfo'),
    shop: t('dashboard.shopPurchases'),
    realmoney: t('dashboard.purchases')
  };

  let content;
  switch (selectedSection) {
    case 'character':
      content = <DashboardCharacterInfo />;
      break;
    case 'shop':
      content = <DashboardShopPurchases />;
      break;
    case 'realmoney':
      content = <DashboardArcaniumPurchases />;
      break;
    default:
      content = <p>{t('dashboard.pleaseSelectSection')}</p>;
  }

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('dashboard.dashboardTitle')} />
      <ButtonContainer>
        {Object.entries(sections).map(([key, label]) => (
          <SectionButton
            key={key}
            onClick={() => setSelectedSection(key)}
            active={selectedSection === key}
          >
            {label}
          </SectionButton>
        ))}
      </ButtonContainer>
      <ContentContainer>{content}</ContentContainer>
    </PageContentComponent>
  );
};

export default DashboardPage;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: center;
`;

const SectionButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  color: ${({ active }) => (active ? '#000' : '#fff')};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

